import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  CheckoutLaybyRootScreenParamList,
  CheckoutRootParamList,
} from "../../../../types";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { LaybyRootScreenContext } from "./context";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { CheckoutLaybyScreen } from "../CheckoutLaybyScreen";
import { PaymentRootScreen } from "../PaymentRootScreen";
import { PaymentActionsContext } from "../PaymentRootScreen/context";
import { SaleState } from "../../../../utilities/data/model/Sale";
import React from "react";

export type CheckoutLaybyRootScreenProps = NativeStackScreenProps<
  CheckoutRootParamList,
  "CheckoutLaybyRootScreen"
>;

export const CheckoutLaybyRootScreen = ({
  navigation,
}: CheckoutLaybyRootScreenProps) => {
  const { sale } = useSaleControllerProvider();

  const Stack = createStackHeaderNavigator<CheckoutLaybyRootScreenParamList>();

  if (!sale) {
    return null;
  }

  const handleOnAfterPayment = React.useCallback(async () => {
    await sale.transitionToState(SaleState.LAYBY_SAVED);
    navigation.reset({
      index: 0,
      routes: [{ name: "CheckoutSummaryRootScreen" }],
    });
    return false;
  }, []);

  return (
    <LaybyRootScreenContext.Provider value={{ sale }}>
      <PaymentActionsContext.Provider
        value={{ onAfterPayment: handleOnAfterPayment }}
      >
        <Stack.Navigator
          screenOptions={{
            animationEnabled: true,
          }}
        >
          <Stack.Group
            screenOptions={{
              headerShown: true,
              headerLeft: () => <ModalCloseButton type="Cancel" />,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              title: "",
            }}
          >
            <Stack.Screen
              name="CheckoutLaybyScreen"
              component={CheckoutLaybyScreen}
            />
            <Stack.Screen
              options={{
                headerShown: false,
              }}
              name="PaymentRootScreen"
              component={PaymentRootScreen}
            />
          </Stack.Group>
        </Stack.Navigator>
      </PaymentActionsContext.Provider>
    </LaybyRootScreenContext.Provider>
  );
};
